<template>
    <v-card :loading="loading > 0">
        <v-card-title>
            {{title}}
            <DateOptions v-model="createdAtRange" default="currentMonth"></DateOptions>
            <v-spacer></v-spacer>
            <!-- Reload Reserve -->
            <v-tooltip
                    top
                    color="primary"
                    content-class="caption iransans font-weight-medium px-3"
            >
                <template #activator="{on}">
                    <v-btn
                            icon
                            v-on="on"
                            small
                            @click="syncReport"
                    >
                        <v-icon :class="{ 'mdi-spin' : loading }">mdi-cached</v-icon>
                    </v-btn>
                </template>

                <span>{{$t('reload')}} </span>
            </v-tooltip>
        </v-card-title>
        <v-card-text>
            <Highcharts :options="chartOptions"/>
        </v-card-text>
    </v-card>
</template>

<script>
    import config from '@/config';
    import Service from '../services/SubscriptionService';
    import SubscriptionClassesService from '../services/SubscriptionClassesService';
    import DateOptions from '../components/DateOptions';
    import moment from 'moment-jalaali';

    import { Chart } from 'highcharts-vue';

    export default {
        components: {
            DateOptions,
            Highcharts: Chart
        },
        watch : {
            createdAtRange(){
                this.syncReport();
            }
        },
        props: {
            filters: {
                default(){
                    return {};
                }
            },
            statuses: {
                default(){
                    return [];
                }
            },
            title: {
                type: String
            }
        },
        async mounted() {
            await this.syncSubscriptionClasses();
            await this.syncReport();
        },
        data() {
            return {
                chartOptions: {
                    chart: {
                        type: 'column'
                    },
                    title: {
                        text: null,
                        useHTML: true,
                        style: {
                            fontFamily: 'IRANSans',
                            fontWeight: 700
                        }
                    },
                    xAxis: {
                        categories: [],
                        labels: {
                            useHTML: true,
                            formatter() {
                                return moment(this.value).format('jYYYY-jMM-jDD');
                            },
                            style: {
                                fontFamily: 'IRANSans',
                                fontWeight: 500
                            }
                        },
                        crosshair: true
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: this.$t('count'),
                            useHTML: true,
                            style: {
                                fontFamily: 'IRANSans',
                                fontWeight: 700
                            }
                        },
                        labels: {
                            overflow: 'justify',
                            style: {
                                fontFamily: 'IRANSans',
                                fontWeight: 500
                            }
                        }
                    },
                    tooltip: {
                        useHTML: true,
                        style: {
                            fontFamily: 'IRANSans'
                        },
                        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y}</b></td></tr>',
                        footerFormat: '</table>',
                        shared: true
                    },
                    legend: {
                        useHTML: true,
                        y: 15,
                        itemStyle: {
                            fontFamily: 'IRANSans',
                            top: 0
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    plotOptions: {
                        column: {
                            stacking: 'normal'
                        }
                    },
                    series: [
                    ]
                },
                subscriptionClasses : [],
                loading: false,
                createdAtRange : [],
                reservationStates: config.reservationStates,
                reports: [],
                locations: {}
            }
        },
        methods: {
            async syncSubscriptionClasses(){
                try {
                    this.loading = true;
                    let {
                        data
                    } = await SubscriptionClassesService.list();
                    this.subscriptionClasses = data.value.subscription_classes;
                    
                } finally {
                    this.loading = false;
                }
            },
            getFilters(){
                let filters = this.filters; 
                filters.created_at = { 
                    'column_name' : 'created_at', 
                    'operand' : 'Between', 
                    value : this.createdAtRange 
                }
                return filters;
            },
            async syncReport() {
                this.loading = true;
                try {
                    let {
                        data
                    } = await Service.getOverviewReport('daily', this.getFilters());
                    this.reports = data.value.subscription_overview;
                } finally {
                    this.loading = false;
                }
                this.updateChart();
            },
            updateChart(){
                let reports = {};
                let categories = [];
                let series = {};

                this.reports.map((report) => {
                    let key = [report.year,report.month,report.day].join('-');
                    let itemReport = reports[key] || {
                        
                    };
                    itemReport[report.subscription_class_id] = report;
                    reports[key] = itemReport;
                });

                let days = Object.keys(reports).sort(function(a,b){
                    // Turn your strings into dates, and then subtract them
                    // to get a value that is either negative, positive, or zero.
                    return new Date(a) - new Date(b);
                });
                days.forEach(key => {
                    let report = reports[key];

                    categories.push(key);

                    this.subscriptionClasses.forEach(subscriptionClass => {
                        
                        let itemData = series[subscriptionClass.id] || {
                            name: subscriptionClass.caption,
                            // color : this.$vuetify.theme.themes.light['fax_' + faxStatus],
                            data: []
                        }
                        itemData.data.push(report[subscriptionClass.id] ? report[subscriptionClass.id].total : 0);

                        series[subscriptionClass.id] = itemData;
                    });

                });

                this.chartOptions.series = Object.values(series);
                this.chartOptions.xAxis.categories = categories;
            }
        }
    }
</script>

